// Décodage local (non vérifié) du payload d'un JWT — uniquement pour de
// l'affichage côté client (ex: heure d'expiration de session). La vérification
// réelle de la signature/expiration reste faite côté serveur.
export function decodeJwtPayload(token) {
  if (!token) return null;
  try {
    const payload = token.split('.')[1];
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const json = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + c.charCodeAt(0).toString(16).padStart(2, '0'))
        .join('')
    );
    return JSON.parse(json);
  } catch {
    return null;
  }
}

// Renvoie la date d'expiration (Date) du token, ou null si absente/invalide.
export function getTokenExpiry(token) {
  const payload = decodeJwtPayload(token);
  if (!payload?.exp) return null;
  return new Date(payload.exp * 1000);
}
